import type {Registration} from '@/types/registration';
import type {Session} from 'next-auth';

export const signedInPaths = ['/dashboard', '/activity', '/benefits', '/household', '/settings'];

export const isAuthenticated = (
  session?: Session | null
): session is Session & {
  state: {name: 'authenticated'; authToken: string};
  user: NonNullable<Session['user']> & {
    name: string;
    email: string;
    role: 'USER' | 'VIEW';
  };
} => {
  return (
    !!session?.user && typeof session?.state === 'object' && session.state.name === 'authenticated'
  );
};

export const isUnauthenticated = (
  session?: Session | null
): session is Session & {state: {name: 'unauthenticated'}} => {
  return typeof session?.state !== 'object' && session?.state === 'unauthenticated';
};

export const isOtpJoinRequired = (
  session?: Session | null
): session is Session & {state: {name: 'otp-join-required'; registration: Registration}} => {
  return (
    !!session?.user &&
    typeof session.state === 'object' &&
    session.state.name === 'otp-join-required' &&
    !!session.state.registration &&
    typeof session.state.registration === 'object' &&
    !!session.state.registration.email
  );
};

export const isOtpRequired = (session?: Session | null): session is Session => {
  return (
    (!!session?.user &&
      typeof session.state === 'object' &&
      session.state.name === 'otp-join-required') ||
    session?.state === 'otp-forgot-password-required'
  );
};

export function getSignoutUrl({from, push = true}: {from?: URL; push?: boolean}) {
  return `/signout?redirect=/login${from ? `&from=${from.pathname}` : ''}${push ? '&push=true' : ''}`;
}
